const handleTableMove = () => {
	const $product = $('.js-product');
	const $prevArrow = $product.find('.js-arrow-prev');
	const $nextArrow = $product.find('.js-arrow-next');
	const $scrollBody = $product.find('.table__inner');

	const scrollMove = 157;

	$nextArrow.on('click', function(event) {
		event.preventDefault();

		const tableOffsetEnd = $product.find('.table__outer').offset().left + $product.find('.table__outer').outerWidth();
		const tableInnerOffsetEnd = $product.find('table').offset().left + $product.find('table').outerWidth();

		const $tableTd = $product.find('table tbody tr:first-child td:not(:first-child)');
		const offset = $scrollBody.scrollLeft() + $tableTd.outerWidth();

		$scrollBody.animate({scrollLeft: offset}, 800);
		$prevArrow.removeClass('is-inactive');

		if ((tableOffsetEnd + 10) >= tableInnerOffsetEnd) {
			$nextArrow.addClass('is-inactive');
		}

	});

	$prevArrow.on('click', function(event) {
		event.preventDefault();

		const $tableTd = $product.find('table tbody tr:first-child td:not(:first-child)');
		const offset = $scrollBody.scrollLeft() - $tableTd.outerWidth();

		$scrollBody.animate({scrollLeft: offset}, 800);
		$nextArrow.removeClass('is-inactive');

		if ($scrollBody.scrollLeft() === 0) {
			$prevArrow.addClass('is-inactive');
		}
	});

	$scrollBody.on('scroll', function(event) {
		event.preventDefault();

		const tableOffsetEnd = $product.find('.table__outer').offset().left + $product.find('.table__outer').outerWidth();
		const tableInnerOffsetEnd = $('table').offset().left + $('table').outerWidth();

		$scrollBody.scrollLeft() === 0 ? $prevArrow.addClass('is-inactive') : $prevArrow.removeClass('is-inactive');

		(tableOffsetEnd + 10) >= tableInnerOffsetEnd ? $nextArrow.addClass('is-inactive') : $nextArrow.removeClass('is-inactive');
	});
};

handleTableMove();
